export default "__VITE_ASSET__60eebbd7__"